// extracted by mini-css-extract-plugin
export var abbr = "Markdown-module--abbr--3FvRs";
export var blockquote = "Markdown-module--blockquote--3ySq5";
export var bxTextTruncateEnd = "Markdown-module--bx--text-truncate--end--2zO-6";
export var bxTextTruncateFront = "Markdown-module--bx--text-truncate--front--2vVU6";
export var h1 = "Markdown-module--h1--3zm7k";
export var h2 = "Markdown-module--h2--2WiaJ";
export var h3 = "Markdown-module--h3--TzXWV";
export var h4 = "Markdown-module--h4--Ykvzb";
export var h5 = "Markdown-module--h5--n1RNd";
export var h6 = "Markdown-module--h6--20o6e";
export var list = "Markdown-module--list--1uTBz";
export var listItem = "Markdown-module--list-item--2Bgvg";
export var paragraph = "Markdown-module--paragraph--245vG";
export var paragraphResponsive = "Markdown-module--paragraph--responsive--3EZO6";
export var sup = "Markdown-module--sup--2SsJc";